export default "__VITE_ASSET__TmGKof41__"